<template>
  <v-icon
    x-small
    @click="copyAccountNumber()"
  >
    mdi-content-copy
  </v-icon>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AccountCopy',
  methods: {
    ...mapActions(['success', 'error']),
    copyAccountNumber() {
      const textArea = document.createElement('textarea');
      try {
        textArea.value = this.$store.getters.account.name;
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.position = 'fixed';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        if (!document.execCommand('copy')) {
          throw new Error('Count not copy account number');
        }
        this.success('Account number copied!');
      } catch (err) {
        this.error('Could not copy account number!');
      } finally {
        document.body.removeChild(textArea);
      }
    },
  },
};
</script>
